var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _vm.participant.ogrn || _vm.participant.inn
      ? _c(
          "span",
          [
            _c(
              "card-link",
              { attrs: { ogrn: _vm.participant.ogrn || _vm.participant.inn } },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.participant.title) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c("tooltip", {
              staticClass: "on-one-row no_print",
              attrs: { ogrn: _vm.participant.ogrn || _vm.participant.inn },
            }),
          ],
          1
        )
      : _c("span", [_vm._v(_vm._s(_vm.participant.title))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }